// Endereço "oficial" da Política de Privacidade (pedido 2026-09-28):
// gpsdrive.com.br/politica-de-privacidade. Mesmo conteúdo de /privacidade,
// que continua no ar porque é o link já cadastrado na Play Store Console.
import { createFileRoute } from "@tanstack/react-router";
import { PrivacyPolicyPage } from "./privacidade";

export const Route = createFileRoute("/politica-de-privacidade")({
  head: () => ({
    meta: [
      { title: "Política de Privacidade — GPS Drive" },
      {
        name: "description",
        content: "Política de Privacidade da plataforma, aplicativo e serviços GPS Drive.",
      },
    ],
  }),
  component: PrivacyPolicyPage,
});
